<template>
  <div>
    <div v-if="fetched" class="bs-date">
      <div v-if="error" class="text-center red lighten-1">
        <span class="white--text">{{ error }}</span>
      </div>
      <v-divider v-if="error"></v-divider>
      <div v-if="!showYears" class="v-date-picker-header">
        <v-btn :disabled="!showDecrementButton" icon @click="decrement">
          <v-icon v-text="$getIcon('mdiChevronLeft')"></v-icon>
        </v-btn>
        <span
          class="subtitle-1 grey--text text--darken-4"
          style="font-family: 'Kalimati'"
          @click="changeView"
          v-html="calendarHeader"
        ></span>
        <v-btn :disabled="!showIncrementButton" icon @click="increment">
          <v-icon v-text="$getIcon('mdiChevronRight')"></v-icon>
        </v-btn>
      </div>
      <div
        v-if="!showYears"
        class="text-center body-2 py-1 green lighten-2 white--text"
        style="min-width: 287px !important;"
      >
        <!--        {{ adYear }}-{{ adMonth }}-{{ adDate }}-->
        {{ selectedAdDate }}
      </div>
      <div v-if="showDates">
        <table class="table fix-layout">
          <thead class="grey--text text--darken-2">
            <tr style="height: 34px;">
              <th class="caption">आ</th>
              <th class="caption">सो</th>
              <th class="caption">मं</th>
              <th class="caption">बु</th>
              <th class="caption">बि</th>
              <th class="caption">शु</th>
              <th class="caption">श</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in monthRows" :key="index">
              <td
                v-for="(obj, index) in row"
                :key="index"
                class="text-center"
                style="height: 33px;"
                @click="onDateClick(obj.split('-')[0])"
              >
                <template
                  v-if="
                    selectedDate !== '' &&
                      selectedDate ===
                        year + '-' + month + '-' + obj.split('-')[0]
                  "
                >
                  <v-btn
                    class="calendarButton"
                    :class="disableDate ? 'shade' : 'green lighten-2'"
                    icon
                    text
                    small
                    floating
                  >
                    <span
                      class="subtitle-1 white--text"
                      style="font-family: 'Kalimati'"
                      v-html="toNepaliNumber(obj.split('-')[0])"
                    ></span>
                  </v-btn>
                </template>
                <template v-else-if="isDateToday(obj)">
                  <v-btn
                    class="calendarButton"
                    :color="disableDate ? 'shade' : 'green lighten-2'"
                    outlined
                    small
                    icon
                  >
                    <span
                      class="subtitle-1"
                      style="font-family: 'Kalimati'"
                      v-html="toNepaliNumber(obj.split('-')[0])"
                    ></span>
                  </v-btn>
                </template>
                <template v-else>
                  <span
                    v-if="obj.split('-')[0]"
                    class="subtitle-2"
                    style="font-family: 'Kalimati'"
                    v-html="toNepaliNumber(obj.split('-')[0])"
                  ></span>
                  <span v-else style="visibility: hidden">-</span>
                  <span class="grey--text font-size-10">{{
                    obj.split("-")[1]
                  }}</span>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="showMonths" class="v-date-picker-table--month">
        <table>
          <tbody>
            <tr>
              <td
                v-for="(item, index) in months_list.slice(0, 3)"
                :key="index"
                class="px-3"
              >
                <v-btn
                  :class="
                    month === index + 1 ? 'green lighten-2 white--text' : ''
                  "
                  :disabled="!showMonthButton"
                  text
                  @click="viewDates(index + 1)"
                  v-text="item"
                ></v-btn>
              </td>
            </tr>
            <tr>
              <td v-for="(item, index) in months_list.slice(3, 6)" :key="index">
                <v-btn
                  :class="
                    month === index + 3 + 1 ? 'green lighten-2 white--text' : ''
                  "
                  :disabled="!showMonthButton"
                  text
                  @click="viewDates(index + 3 + 1)"
                  v-text="item"
                ></v-btn>
              </td>
            </tr>
            <tr>
              <td v-for="(item, index) in months_list.slice(6, 9)" :key="index">
                <v-btn
                  :class="
                    month === index + 6 + 1 ? 'green lighten-2 white--text' : ''
                  "
                  :disabled="!showMonthButton"
                  text
                  @click="viewDates(index + 6 + 1)"
                  v-text="item"
                ></v-btn>
              </td>
            </tr>
            <tr>
              <td
                v-for="(item, index) in months_list.slice(9, 12)"
                :key="index"
              >
                <v-btn
                  :class="
                    month === index + 9 + 1 ? 'green lighten-2 white--text' : ''
                  "
                  text
                  @click="viewDates(index + 9 + 1)"
                  v-text="item"
                ></v-btn>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        v-show="showYears"
        class="scrollbar-sm scroll-to-view"
        style="max-height: 350px; width: 290px"
      >
        <div
          v-for="(item, index) in years_list"
          :key="index"
          class="text-center"
        >
          <v-btn
            :class="
              year === parseInt(item)
                ? 'green lighten-2 white--text active-year'
                : ''
            "
            text
            style="font-family: 'Kalimati'"
            @click="(year = parseInt(item)), changeView()"
            v-html="toNepaliNumber(item)"
          ></v-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NepaliCalendarMixin from "@/mixins/NepaliCalendarMixin";
export default {
  mixins: [NepaliCalendarMixin],
  props: {
    value: {
      type: String,
      default: ""
    },
    // error: {
    //   type: String,
    //   default: ''
    // },
    localizedDate: {
      type: String,
      default: ""
    },
    disableDate: {
      type: Boolean,
      default: false
    },
    fiscalYear: {
      type: Array,
      required: true
    },
    addExtraYear: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      numberMapping: {
        0: "&#2406",
        1: "&#2407",
        2: "&#2408",
        3: "&#2409",
        4: "&#2410",
        5: "&#2411",
        6: "&#2412",
        7: "&#2413",
        8: "&#2414",
        9: "&#2415"
      },
      year: "",
      month: "",
      day: "",
      selectedDate: "",
      years_list: "",
      months_list: "",
      days_list: "",
      showDates: true,
      showMonths: false,
      showYears: false,
      fetched: false,
      error: ""
    };
  },
  computed: {
    bsDate() {
      if (this.year && this.month && this.day) {
        const monthPadding = this.month < 10 ? "0" : "";
        const datePadding = this.day < 10 ? "0" : "";
        return `${this.year}-${monthPadding}${this.month}-${datePadding}${this.day}`;
      }
      return "";
    },
    adFullDate() {
      if (this.year && this.month && this.day) {
        return new Date(this.bs2ad(`${this.year}-${this.month}-${this.day}`));
      }
      return new Date();
    },
    adYear() {
      return this.adFullDate.getFullYear();
    },
    adMonth() {
      return this.$dayjs(this.adFullDate).format("MMM");
    },
    adDate() {
      return this.adFullDate.getDate();
    },
    selectedAdDate() {
      if (this.selectedDate) {
        const adDate = new Date(this.bs2ad(this.selectedDate));
        return (
          adDate.getFullYear() +
          "-" +
          this.$dayjs(adDate).format("MMM") +
          "-" +
          adDate.getDate()
        );
      }
      return "- - -";
    },
    monthStartDay() {
      const bsMonthStartDateInAd = new Date(
        this.bs2ad(`${this.year}-${this.month}-${1}`)
      );
      return bsMonthStartDateInAd.getDay() + 1;
    },
    monthDays() {
      return this.getMonthDays(this.year, this.month);
    },
    monthRows() {
      const rows = [];
      let date = 1;
      let firstRow = true;
      let rowCount = 0;
      do {
        rowCount++;
        const newBSRow = [];
        for (let i = 1; i <= 7; i++) {
          if (firstRow) {
            if (i < this.monthStartDay) {
              newBSRow.push("");
            } else {
              newBSRow.push(date + "-" + this.getAdDate(date));
              date = date + 1;
            }
          } else {
            if (date <= this.monthDays) {
              newBSRow.push(date + "-" + this.getAdDate(date));
              date = date + 1;
            } else {
              newBSRow.push("");
            }
          }
        }
        firstRow = false;
        rows.push(newBSRow);
      } while (date <= this.monthDays);
      // For making the table row count = 6 for UI consistency
      if (rowCount < 6) {
        rows.push(["", "", "", "", "", "", ""]);
      }
      return rows;
    },
    calendarHeader() {
      if (this.showDates) {
        return (
          this.months_list[this.month - 1] +
          " " +
          this.toNepaliNumber(this.year)
        );
      } else if (this.showMonths) {
        return this.toNepaliNumber(this.year);
      }
      return "";
    },
    showDecrementButton() {
      return (
        parseInt(this.year) !== parseInt(this.years_list[0]) ||
        (this.month > parseInt(this.bsEquivalent.split("-")[1]) + 1 &&
          this.showDates)
      );
    },
    showIncrementButton() {
      return (
        parseInt(this.year) !==
          parseInt(this.years_list[this.years_list.length - 1]) ||
        (this.getMonths()[this.getMonths().length - 1] !==
          this.months_list[this.month - 1] &&
          this.showDates)
      );
    },
    showMonthButton() {
      return parseInt(this.year) !== parseInt(this.years_list[0]);
    }
  },
  watch: {
    value: function(newVal) {
      if (!newVal || newVal.length !== 10) {
        this.$emit("input", "");
        this.$emit("update:localizedDate", "");
        this.day = "";
        this.selectedDate = "";
      } else {
        const convertedBsDate = this.ad2bs(newVal);
        const [year, month, day] = convertedBsDate
          .split("-")
          .map(data => parseInt(data));
        this.year = year;
        this.month = month;
        this.day = day;
        this.selectedDate = year + "-" + month + "-" + day;
      }
    },
    bsDate: function(newVal) {
      if (newVal) {
        // const convertedBsDate = this.ad2bs(newVal)
        const [year, month, day] = newVal
          .split("-")
          .map(data => parseInt(data));
        this.year = year;
        this.month = month;
        this.day = day;
      }
      // const modVal = this.bs2ad(newVal)
      // this.$emit('input', modVal)
      // this.$emit('update:localizedDate', newVal)
    }
  },
  mounted() {
    this.value && this.$emit("update:localizedDate", this.bsDate);
  },
  async created() {
    let yearList = [];
    let minMapping = "";
    let maxMapping = "";
    if (this.fiscalYear.length === 0) {
      yearList = Object.keys(this.bs);
      minMapping = yearList[0];
      maxMapping = yearList[yearList.length - 1];
    } else {
      const minApplicableDate = this.fiscalYear[this.fiscalYear.length - 1]
        .applicable_from;
      const minBsApplicableDate = parseInt(
        this.ad2bs(minApplicableDate).split("-")[0]
      );
      const maxApplicableDate = this.fiscalYear[0].applicable_to;
      // extra added year is shown in calendar for future date selection
      const maxBsApplicableDate =
        parseInt(this.ad2bs(maxApplicableDate).split("-")[0]) +
        this.addExtraYear;
      for (const key of Object.keys(this.bs)) {
        if (
          parseInt(key) >= minBsApplicableDate &&
          parseInt(key) <= maxBsApplicableDate
        ) {
          yearList.push(key);
        }
      }
      minMapping = yearList.sort((a, b) => a - b)[0];
      maxMapping = yearList.sort((a, b) => a - b)[yearList.length - 1];
    }
    const limitMapping = {
      max: this.bs2ad(`${maxMapping}-12-${this.bs[maxMapping][11]}`),
      min: this.bs2ad(`${minMapping}-01-01`)
    };
    this.$emit("limit-mapping", limitMapping);

    // this.years_list = this.getYears()
    this.years_list = yearList;
    this.months_list = this.getMonths();
    this.days_list = this.getDays();

    let adDate = null;
    if (this.value) {
      adDate = this.value;
    } else {
      const today = new Date();
      adDate = `${today.getFullYear()}-${today.getMonth() +
        1}-${today.getDate()}`;
    }
    const convertedBsDate = this.ad2bs(adDate);
    const [year, month, day] = convertedBsDate
      .split("-")
      .map(data => parseInt(data));
    this.year = year;
    this.month = month;
    if (this.value) {
      // this.disableDate ? this.day = 1 : this.day = day
      this.day = day;
      this.selectedDate = year + "-" + month + "-" + day;
    }
    this.fetched = true;
  },
  methods: {
    onDateClick(data) {
      if (this.disableDate || !data) return;
      // if (data !== this.day) {
      //   if (this.year && this.month && !this.day)
      this.day = data;
      this.selectedDate = this.year + "-" + this.month + "-" + data;
      this.$emit("input", this.bs2ad(this.bsDate));
      this.$emit("update:localizedDate", this.bsDate);
      // this.day = data
      // }
    },

    getAdDate(nepaliDate) {
      const adMonth = this.bs2ad(
        `${this.year}-${this.month}-${nepaliDate}`
      ).split("-")[2];
      return parseInt(adMonth);
    },
    incMonth() {
      if (this.month + 1 > 12) {
        if (this.validateIncrementedYear()) {
          this.month = 1;
          this.year = this.year + 1;
        }
      } else {
        // this.day = 1
        this.month = this.month + 1;
      }
    },
    decMonth() {
      if (this.month - 1 < 1) {
        if (this.validateDecrementedYear()) {
          // this.day = 1
          this.month = 12;
          this.year = this.year - 1;
        }
      } else {
        // this.day = 1
        this.month = this.month - 1;
      }
    },
    incYear() {
      if (this.validateIncrementedYear()) {
        this.year = this.year + 1;
      }
    },
    decYear() {
      if (this.validateDecrementedYear()) {
        this.year = this.year - 1;
      }
    },
    decrement() {
      if (this.showMonths) {
        this.decYear();
      } else if (this.showDates) {
        this.decMonth();
      }
    },
    increment() {
      if (this.showMonths) {
        this.incYear();
      } else if (this.showDates) {
        this.incMonth();
      }
    },
    changeView() {
      if (this.showDates) {
        this.showDates = false;
        this.showMonths = true;
        this.showYears = false;
      } else if (this.showMonths) {
        this.showDates = false;
        this.showMonths = false;
        this.showYears = true;
        this.$nextTick(() => {
          const scrollableDiv1 = document.getElementsByClassName(
            "active-year"
          )[0];
          if (typeof scrollableDiv1 !== "undefined") {
            const offset1 = scrollableDiv1.offsetTop;
            document.getElementsByClassName("scroll-to-view")[0].scrollTop =
              offset1 - 100;
          }
          const scrollableDiv2 = document.getElementsByClassName(
            "active-year"
          )[1];
          if (typeof scrollableDiv2 !== "undefined") {
            const offset2 = scrollableDiv2.offsetTop;
            document.getElementsByClassName("scroll-to-view")[1].scrollTop =
              offset2 - 100;
          }
        });
      } else {
        this.showDates = false;
        this.showMonths = true;
        this.showYears = false;
      }
    },
    viewDates(month) {
      this.month = month;
      this.showDates = true;
      this.showMonths = false;
    },
    validateIncrementedYear() {
      const bsYearList = Object.keys(this.bs);
      if (parseInt(this.year) === parseInt(bsYearList[bsYearList.length - 1])) {
        this.error = `Year cannot be greater than ${
          bsYearList[bsYearList.length - 1]
        }.`;
        setTimeout(() => {
          this.error = "";
        }, 1500);
        return false;
      }
      return true;
    },
    validateDecrementedYear() {
      const bsYearList = Object.keys(this.bs);
      if (parseInt(this.year) === parseInt(bsYearList[0])) {
        this.error = `Year cannot be smaller than ${bsYearList[0]}.`;
        setTimeout(() => {
          this.error = "";
        }, 1500);
        return false;
      }
      return true;
    },
    toNepaliNumber(number) {
      const digits = ("" + number).split("");
      let nepaliDigit = "";
      digits.forEach(x => {
        nepaliDigit += this.numberMapping[x];
      });
      return nepaliDigit;
    },
    isDateToday(obj) {
      const today = this.ad2bs(this.$dayjs().format("YYYY-MM-DD"));
      if (
        parseInt(today.split("-")[0]) === parseInt(this.year) &&
        parseInt(today.split("-")[1]) === parseInt(this.month) &&
        parseInt(today.split("-")[2]) === parseInt(obj.split("-")[0])
      ) {
        return true;
      }
    }
  }
};
</script>
<style>
table.fix-layout {
  table-layout: fixed;
  height: 224.44px;
}
table.fix-layout td {
  padding: 2px !important;
}
table.fix-layout th {
  width: 39px !important;
  font-size: 16px !important;
  font-weight: normal;
}
.v-date-picker-header {
  padding: 0px 16px !important;
}
.calendarButton {
  margin: 0 !important;
}
.bs-date {
  width: max-content;
  background: white;
}
.font-size-10 {
  font-size: 10px;
}
</style>
